// @flow
import React from 'react'

const ArrowRight = () => {
  return (
    <svg width="9px" height="16px" viewBox="0 0 9 16" version="1.1">
      <defs />
      <g id="Booking-Form" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Admin---Calendar-Days" transform="translate(-678.000000, -1075.000000)">
          <g id="Page" transform="translate(330.000000, 120.000000)">
            <g id="Calendar-Drop-Down" transform="translate(40.000000, 933.000000)">
              <g id="Top" transform="translate(20.000000, 18.000000)">
                <g id="minimal-right" transform="translate(284.000000, 4.000000)">
                  <rect id="Rectangle-path" x="0" y="0" width="16" height="16" />
                  <g
                    id="Group"
                    transform="translate(4.000000, 0.000000)"
                    stroke="#6E7B8C"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline id="Shape" points="0.5 0.5 8 8 0.5 15.5" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default ArrowRight



// WEBPACK FOOTER //
// ./src/components/Icons/ArrowRight.js